import React from "react";
import { useTranslation } from "react-i18next";
import BlockItem from "../../Components/BlockItem";
import UserPermissionWidget from "../../UserPermissionWidget";

function GroupModule({ viewModule }) {
  const user = JSON.parse(localStorage.getItem("user"));
  const { t } = useTranslation();

  return (
    <div className={`home-cards-box ${!viewModule ? "d-none" : ""}`}>
      <h1 className="cards__title">
        <img className="cards__img" src="images/cards-3.png" alt="card box" />
        {t("home_groups_manage")}
      </h1>
      <section className="section-page config">
        <UserPermissionWidget hasPermission={user?.permissions?.view_groups}>
          <BlockItem
            link="/groups/main-group"
            title={t("home_groups")}
            image="images/group-1.png"
          />
        </UserPermissionWidget>
        {/* <BlockItem
      link="/groups/archived-group"
      title="Yangi guruh jurnalini ochish va sozlash "
      image="images/group-1.png"
    /> */}
        <UserPermissionWidget hasPermission={user?.permissions?.view_exams}>
          <BlockItem
            link="/groups/exam-list"
            title={t("home_exams")}
            image="images/group-1.png"
          />
        </UserPermissionWidget>
        <UserPermissionWidget
          hasPermission={user?.permissions?.move_student_to_other_group}
        >
          <BlockItem
            link="/group-management/students-transfer"
            title={t("home_student_transfer")}
            image="/images/config-img-6.png"
          />
        </UserPermissionWidget>
        <UserPermissionWidget
          hasPermission={user?.permissions?.students_group_changes}
        >
          <BlockItem
            link="/group-management/students-transfer-lists"
            title={t("home_student_transfer_list")}
            image="/images/config-img-6.png"
          />
        </UserPermissionWidget>
      </section>
    </div>
  );
}

export default GroupModule;
